import styled from 'styled-components';

export const ButtonGroupFilter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
`;
